import Vue from 'vue'
import Router from 'vue-router'
import LoginParticipant from '@/components/loginParticipant/Login.vue'
import ParticipantOnline from '@/components/loginParticipant/online.vue'
import FreeUpload from '@/components/FreeUpload'

Vue.use(Router)

export default new Router({
  scrollBehavior (to, from, savedPosition) {
    return {x: 0, y: 0}
  },
  beforeEnter: (to, from, next) => {
    const { uri } = to.query
    if (uri != null && uri !== '/') {
      next(false)
      this.$router.push(uri)
    } else {
      next()
    }
  },
  hashbang: false,
  history: true,
  linkActiveClass: 'active-class',
  routes: [
    {
      path: '/',
      component: LoginParticipant
    },
    {
      path: '/online',
      component: ParticipantOnline
    },
    {
      path: '/Anmeldung',
      name: 'AnmeldungAlternative',
      component: LoginParticipant
    },
    {
      path: '/Upload/:token',
      component: FreeUpload
    },
    {
      path: '/:partnerGuid',
      component: LoginParticipant
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js